import { UsersPendingTab } from "./UsersPendingTab";

export default UsersPendingTab;
